import React from 'react';

export default function ThspianIcon({ fill = '#E38627', ...rest }: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>
            {/* Smaller center circle */}
            <circle cx="12" cy="12" r="2" fill="none" stroke={fill} strokeMiterlimit="10" strokeWidth="1.91" />

            {/* Outer path remains unchanged */}
            <path
                d="M14.86,8.18v6a1.67,1.67,0,0,0,1.67,1.67h0a1.64,1.64,0,0,0,1.48-.9,6.65,6.65,0,0,0,.63-3.67,6.69,6.69,0,1,0-4.23,7"
                fill="none"
                stroke={fill}
                strokeMiterlimit="10"
                strokeWidth="1.91"
            />

            {/* Larger corner radius */}
            <rect
                x="1.5"
                y="1.5"
                width="21"
                height="21"
                rx="6" // ← increased from 3.82
                fill="none"
                stroke={fill}
                strokeMiterlimit="10"
                strokeWidth="1.91"
            />
        </svg>
    );
}
